import Hashids from 'hashids'

export function useHashids () {
  const config = useRuntimeConfig()
  const hashids = new Hashids(config.app.hashidsSalt as string, 16)

  return hashids
}
